<ng-container *ngIf="list">
	<div [ngClass]="{'default': list.defaultList}" class="list-card hmf-subtle-shadow hmf-display-flex hmf-mb-m hmf-p-xxs" (click)="openListDetails()">
		<img
			[src]="imageSrc"
			[alt]="list.displayName"
			(error)="handleCardImageError($event)"
			height="90"
			width="90"
			class="list-card-image">
		<div class="hmf-pl-xxs">
			<p class="hmf-header-bold-xs hmf-text-align-left list-card-title">{{list.displayName}}</p>
			<p class="hmf-header-xs hmf-pb-xxs">{{list.productCount | dcsgListSubheading: list.defaultList : false : true : recommendedListDescription}}</p>
			<p *ngIf="list.listType?.toLowerCase() === 'recommended'" class="list-card-data-driven-badge hmf-body-bold-s hmf-m-0 hmf-pt-xxxs">Made For You</p>
		</div>
	</div>
</ng-container>
